export default "__VITE_ASSET__nBEmDMt3__"